import Icon, { Icons } from '@/presentation/components/elements/Icon';
import AssetCard from '@/presentation/components/modules/AssetCard';
import InfiniteScroll from '@/presentation/components/modules/InfiniteScroll';
import { Asset, TokenId, getTotalTokenIds } from 'nftx.js';
import { useState } from 'react';
import { QueryStatus } from '@tanstack/react-query';

export interface AssetsProps {
  tokenIds: [TokenId, number][];
  assets?: Asset[];
  assetsStatus: QueryStatus;
  maxItems: number;
  is1155: boolean;
  onToggleTokenId: (tokenId: TokenId) => void;
  onQuantityChange: (tokenId: TokenId, quantity: number) => void;
}

const Assets = ({
  assets,
  assetsStatus,
  tokenIds,
  maxItems,
  onToggleTokenId,
  is1155,
  onQuantityChange,
}: AssetsProps) => {
  const [visibleIndex, setVisibleIndex] = useState(8);

  const visibleAssets = assets?.slice(0, visibleIndex);
  const scrollable = !!(
    assets &&
    visibleAssets &&
    assets.length > visibleAssets.length
  );

  return (
    <div>
      {assetsStatus === 'loading' && (
        <div className="p-6 flex justify-center items-center">
          <Icon name={Icons.SPINNER_GAP} className="animate-spin" size={24} />
        </div>
      )}
      {assetsStatus === 'success' && !assets?.length && (
        <div className="text-center space-y-4">
          <Icon name={Icons.GHOST} className="text-pink-500" size={32} />
          <h4>{'No items in vault.'}</h4>
          <p className="text-center p-6">
            {'There are no assets within NFTX for this collection.'}
          </p>
        </div>
      )}
      <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5  gap-2 pb-12 px-4 pt-4 max-h-96 overflow-y-scroll hide-scroll">
        <InfiniteScroll
          onLoadMore={() => setVisibleIndex((x) => x + 8)}
          scrollable={scrollable}
        >
          {visibleAssets?.map((ass) => {
            const selectedItem = tokenIds.find(
              ([tokenId]) => tokenId === ass.tokenId
            );
            const selected = !!selectedItem;
            const selectedQuantity = selectedItem?.[1] ?? 1;
            const disabled =
              !selected && getTotalTokenIds(tokenIds) >= maxItems;

            return (
              <AssetCard
                shadow={false}
                key={ass.id}
                onClick={() => onToggleTokenId(ass.tokenId)}
                selected={selected}
                dateAdded={ass.dateAdded}
                disabled={disabled}
                is1155={is1155}
                selectedQuantity={selectedQuantity}
                onQuantityChange={(value) =>
                  onQuantityChange(ass.tokenId, value)
                }
                {...ass}
              />
            );
          })}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default Assets;
